import { getAllDevices } from "./endpoints";

const getAllDevicesForAdmin = async (token) =>  {
    try {
      const data = await getAllDevices(token);
  
      return data.map((device, index) => ({
        ...device,
        id: device.id || `device-${index}`,
      }));
    
    } catch (error) {
      console.error("Failed to fetch all devices:", error);
      throw error;
    }
  };

  export default getAllDevicesForAdmin;
  
  